import api from "../instance/axios_instance.ts";
const TypeUserApi = async (): Promise<any> => {

    try {
        const response = await api.get('/type_user', { skipAuth: true } as any);
        return response;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};

export default TypeUserApi;